const PATH = '/';

export default PATH;
